module.exports = __webpack_public_path__ + "img/bj_2.8c001cc2.png";